module.exports = {
  content: {
    'zh-CN': '作为专业的移动手机游戏发行公司，EnjoyGame<br />致力于将中国精品手机游戏输出和发行到海外市场。目前发<br />行范围覆盖港澳台、东南亚、亚太、欧美等上百个国家和地区。其发<br />行的《天域战记》、《幻想之刃》、《暗黑联盟》等多款产品在海外地区广受<br />欢迎，多次获得谷歌和苹果的推荐，在各榜单上均有优异表现。目前Enjoygame在持<br />续招贤纳士，并积极寻求与更多优秀的国内外产品和机构的合作。',
	'zh-TW': '作為專業的移動手機遊戲發行公司，EnjoyGame<br />致力於將中國精品手機遊戲輸出和發行到海外市場。目前發<br />行範圍覆蓋港澳台、東南亞、亞太、歐美等上百個國家和地區。其發<br />行的《天域戰記》、《幻想之刃》、《暗黑聯盟》等多款產品在海外地區廣受<br />歡迎，多次獲得谷歌和蘋果的推薦，在各榜單上均有友誼表現。目前EnjoyGame在持<br />續招賢納士，并積極尋求與更多優秀的國內外產品和機構的合作。',
    'en-US': 'As a professional mobile games distribution <br /> company, EnjoyGame is committed to output and distribute<br /> Chinese excellent mobile games to overseas markets.  The current<br /> distribution covers Hong Kong, Macao, Southeast Asia, Asia-Pacific, Europe and<br /> the United States, etc. more than 100 countries and regions. Our games-"Paradise War", <br />"Sword of Fantasy", "League Dark" and other products are popular overseas. And they are repeatedly<br /> featured by Google Play and App Store. Currently EnjoyGame is still looking for more excellent elites, <br />domestic and foreign products and institutions for cooperation.',
    'th-TH': 'As a professional mobile games distribution <br /> company, EnjoyGame is committed to output and distribute<br /> Chinese excellent mobile games to overseas markets.  The current<br /> distribution covers Hong Kong, Macao, Southeast Asia, Asia-Pacific, Europe and<br /> the United States, etc. more than 100 countries and regions. Our games-"Paradise War", <br />"Sword of Fantasy", "League Dark" and other products are popular overseas. And they are repeatedly<br /> featured by Google Play and App Store. Currently EnjoyGame is still looking for more excellent elites, <br />domestic and foreign products and institutions for cooperation.'
  },
  cooperation: {
    'zh-CN': '商务合作',
	'zh-TW': '商務合作',
    'en-US': 'Business Cooperation',
    'th-TH': 'Business Cooperation'
  },
  hr: {
    'zh-CN': '求职需求',
	'zh-TW': '求職需求',
    'en-US': 'Job Opportunities',
    'th-TH': 'Job Opportunities'
  },
  cs: {
    'zh-CN': '客服需求',
	'zh-TW': '客服需求',
    'en-US': 'Customer Service',
    'th-TH': 'Customer Service'
  },
  haveGoodProduction: {
    'zh-CN': '有好的游戏产品？',
	'zh-TW': '有好的遊戲產品？',
    'en-US': 'Have good production?',
    'th-TH': 'Have good production?'
  },
  goToSubmit: {
    'zh-CN': '前往提交',
	'zh-TW': '前往提交',
    'en-US': 'Submit',
    'th-TH': 'Submit'
  }
};



// WEBPACK FOOTER //
// ./src/lang/business.js